'use strict'

/*
 * Module qui contient les données des profils et les persistes
 * dans les cookies en JSON
 */

let profiles = {}
let currentProfile = {
    name: '',
    gender: '',
    selected: false,
    sizes: {}
}

const COOKIE_NAME = 'MP'
const LINK_EVENT_DELETE_COOKIE = '.j_deleteCookie'
const URL_UPDATE_COOKIE = '/_3MPlus/UpdateCookie'

/*
 * Récupère le cookie du profil s'il existe, et créer l'objet correspondant.
 */
function init() {
    profiles = getCookie()
    if (profiles === undefined) {
        profiles = {}
    } else {
        for (const property in profiles) {
            if (profiles.hasOwnProperty(property)) {
                if (profiles[property].selected === true) {
                    currentProfile = profiles[property]
                }
            }
        }
    }
}

/*
 * Récupère le cookie s'il existe et le transforme en objet
 */
function getCookie() {
    const name = COOKIE_NAME + '='
    const cookiesArray = document.cookie.split(';')
    let cookie = ''

    for (let i = 0; i < cookiesArray.length; i++) {
        // On récupère le cookie
        cookie = cookiesArray[i].trim()

        if (cookie !== undefined) {
            if (cookie.indexOf(name) === 0) {
                return JSON.parse(cookie.substring(name.length, cookie.length)) // On transforme le cookie en object
            }
        }
    }
    return undefined
}

/*
 * Enregistre le cookie
 */
function saveCookie() {
    const now = new Date()

    for (const i in profiles) {
        deleteObjectProperty(profiles[i], 'version')
        deleteObjectProperty(profiles[i], 'customProfile')
        deleteObjectProperty(profiles[i], 'research')
    }

    const myDressingProfile = JSON.stringify(profiles)

    now.setTime(now.getTime() + 3650 * 24 * 60 * 60 * 1000) // le cookie expire dans 10 ans

    document.cookie =
        COOKIE_NAME +
        '=' +
        myDressingProfile +
        ';expires=' +
        now.toGMTString() +
        ';domain=' +
        window.location.hostname +
        ';path=/'

    // Envoi du cookie au serveur pour sauvegarde
    $.ajax({
        url: URL_UPDATE_COOKIE,
        success: function (data) {}
    })
}

function deleteObjectProperty(o, prop) {
    if (o.hasOwnProperty(prop)) {
        delete o[prop]
    }
}

/*
 * Supprime le cookie
 */
function deleteCookie() {
    document.cookie =
        COOKIE_NAME +
        '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' +
        ';domain=' +
        window.location.hostname +
        ';path=/'
}

/*
 * Récupère les données présent dans les éléments $category et $selectedSize
 * qui représente une partie du DOM
 */
function saveDataAsCookie(category, name, dataArray, dataFamily) {
    let family = ''

    if (name === '') {
        return
    }

    if (profiles !== undefined) {
        // Si on avait déjà un profil sélectionné avant, on le désélectionne
        for (const property in profiles) {
            if (profiles.hasOwnProperty(property)) {
                if (profiles[property].selected === true) {
                    profiles[property].selected = false
                }
            }
        }
    }
    if (profiles[name] !== undefined) {
        currentProfile = profiles[name]
        currentProfile.selected = true
        currentProfile.sizes = {}
    } else {
        profiles[name] = {
            name: name,
            gender: category,
            selected: true,
            sizes: {}
        }
        currentProfile = profiles[name]
    }

    // Pour chaque élément option sélectionné, on enregistre ca valeur sous forme family=value
    for (const item in dataArray) {
        if (item !== undefined) {
            if (dataArray.hasOwnProperty(item)) {
                family = item
                profiles[name].sizes[family] = dataArray[item]
            }
        }
    }

    if (profiles[name].lastupdated == null) {
        profiles[name].lastupdated = {}
    }

    if (profiles[name].lastupdated[dataFamily] == null) {
        profiles[name].lastupdated[dataFamily] = []
    }

    profiles[name].lastupdated[dataFamily] = new Date().toISOString()

    saveCookie()
}

/*
 * Vérifie si il existe un profil pour le nom passé en paramètre
 */
function existProfil(name) {
    if (profiles[name] === undefined) {
        return false
    } else if (profiles[name] !== undefined) {
        return true
    }
}

/*
 * Vérifie si il existe un profil pour le genre passé en paramètre
 * retourne son nom ou undefined
 */
function existProfilByGender(gender) {
    let name

    for (const i in profiles) {
        // On compte combien de profils on a dans notre cookie
        if (profiles.hasOwnProperty(i)) {
            if (profiles[i].gender === gender) {
                name = profiles[i].name
            }
        }
    }
    return name
}

/*
 * Récupère le cookie des profils
 * et compte combien il y a de profils a l'intérieur
 */
function getNbOfProfile() {
    let cpt = 0

    for (const i in profiles) {
        // On compte combien de profils on a dans notre cookie
        if (profiles.hasOwnProperty(i)) {
            cpt++
        }
    }
    return cpt
}

/*
 * Va sortir le profil qui a le numéro le plus élevé
 */
function getMaxNbOfProfile() {
    let cpt = 0
    let tmpcpt = 0

    for (const i in profiles) {
        if (profiles.hasOwnProperty(i)) {
            if (!isNaN(parseInt(profiles[i].name.slice(-1)))) {
                tmpcpt = parseInt(profiles[i].name.slice(-1))
                if (tmpcpt > cpt) {
                    cpt = tmpcpt
                }
            }
        }
    }
    return cpt
}

/*
 * Set le profil concerné en selected et set l'ancien
 * profil qui était sélectionné en non sélectionné
 */
function setSelected(name) {
    init()
    profiles[currentProfile.name].selected = false
    profiles[name].selected = true
    currentProfile = profiles[name]
    saveCookie()
}

function getProfileByGender(gender) {
    for (const i in profiles) {
        if (profiles.hasOwnProperty(i)) {
            if (profiles[i].gender === gender) {
                return profiles[i]
            }
        }
    }
    return undefined
}

function getProfiles() {
    return profiles
}

function getCurrentProfile() {
    return currentProfile
}

function setEventDeleteProfileAndReloadPage() {
    $(LINK_EVENT_DELETE_COOKIE).on('click', function (event) {
        deleteCookie()
        location.reload()
    })
}

// Appel du constructeur
init()

export default {
    init: init,
    getProfiles: getProfiles,
    getCurrentProfile: getCurrentProfile,
    saveCookie: saveCookie,
    deleteCookie: deleteCookie,
    saveDataAsCookie: saveDataAsCookie,
    existProfil: existProfil,
    existProfilByGender: existProfilByGender,
    getNbOfProfile: getNbOfProfile,
    setSelected: setSelected,
    getMaxNbOfProfile: getMaxNbOfProfile,
    getProfileByGender: getProfileByGender,
    setEventDeleteProfileAndReloadPage: setEventDeleteProfileAndReloadPage
}
